import {gql} from "@irati/utils/gql"
import internalProductPermissions from "../fragments/internalProductPermissions"

const query = gql`
  mutation ssoAdminLogin($token: String!, $authProvider: AuthProvider) {
    ssoAdminLogin(googleAccessToken: $token, authProvider: $authProvider) {
      accessToken
      user {
        uuid
        firstname
        lastname
        email
      }
      productPermissions {
        ...fullInternalProductPermissions
      }
    }
  }
  ${internalProductPermissions}
`

export const toString = query.loc.source.body

export default query
